import { render } from "./PackageDocumentSummary.vue?vue&type=template&id=42ab22c0&scoped=true"
import script from "./PackageDocumentSummary.vue?vue&type=script&lang=js"
export * from "./PackageDocumentSummary.vue?vue&type=script&lang=js"

import "./PackageDocumentSummary.vue?vue&type=style&index=0&id=42ab22c0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ab22c0"]])

export default __exports__